import { Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import CodeTagIcon from "../../../Assets/svgs/CodeTagIcon";
import MobileBottomRightIcon from "../../../Assets/svgs/MobileWidgetPosition/MobileBottomRightIcon";
import MobileLeftMidIcon from "../../../Assets/svgs/MobileWidgetPosition/MobileLeftMidIcon";
import MobileMidBottomIcon from "../../../Assets/svgs/MobileWidgetPosition/MobileMidBottomIcon";
import MobileMidMidIcon from "../../../Assets/svgs/MobileWidgetPosition/MobileMidMidIcon";
import MobileMidRightIcon from "../../../Assets/svgs/MobileWidgetPosition/MobileMidRightIcon";
import MobileTopRightIcon from "../../../Assets/svgs/MobileWidgetPosition/MobileTopRightIcon";
import BottomRightIcon from "../../../Assets/svgs/WidgetPosition/BottomRightIcon";
import LeftMidIcon from "../../../Assets/svgs/WidgetPosition/LeftMidIcon";
import MidBottomIcon from "../../../Assets/svgs/WidgetPosition/MidBottomIcon";
import MidMidIcon from "../../../Assets/svgs/WidgetPosition/MidMidIcon";
import MidRightIcon from "../../../Assets/svgs/WidgetPosition/MidRightIcon";
import TopRightIcon from "../../../Assets/svgs/WidgetPosition/TopRightIcon";
import ChipsInput from "../../../Common/ChipsInput";
import {
  ALL_CALLING_CODES,
  WIDGET_POSITION,
  WidgetIcons,
} from "../../../Common/Constants";
import {
  emailValidation,
  validWidgetWebsiteURL,
} from "../../../Common/Validations";
import WidgetEmbeddedModal from "../../../Model/WidgetEmbeddedModal";
import { updateWebsiteWidgetLink } from "../../../Redux/Slice/Assistant/WebsiteWidget/UpdateWebsiteWidgetLinkSlice";
import TopMidIcon from "../../../Assets/svgs/WidgetPosition/TopMidIcon";
import TopLeftIcon from "../../../Assets/svgs/WidgetPosition/TopLeftIcon";
import BottomLeftIcon from "../../../Assets/svgs/WidgetPosition/BottomLeftIcon";
import { maskNoByCallingCode } from "../../../Common/utils";
import CountryPhoneInput from "../../../Common/CountryPhoneInput";

const WebsiteWidgetTab = ({
  isTabSelected,
  widgetData,
  handleChange,
  formError,
  setFormError,
  assistantId,
  setIsLoading,
  showSuccessMessage,
  showErrorMessage,
}) => {
  const dispatch = useDispatch();
  const [showWidgetEmbeddedCode, setShowWidgetEmbeddedCode] = useState(false);

  const validateInput = (websiteUrl) => {
    const isValid = validWidgetWebsiteURL(websiteUrl);
    if (isValid || websiteUrl?.trim() === "") {
      const checkItAlreadyExists = widgetData?.websites?.find(
        (website) => website === websiteUrl
      );
      if (checkItAlreadyExists) {
        setFormError({
          ...formError,
          widgetWebsiteUrlError: "Website already exists.",
        });
      } else {
        setFormError({ ...formError, widgetWebsiteUrlError: "" });
      }
    } else {
      setFormError({
        ...formError,
        widgetWebsiteUrlError: "Please enter valid url",
      });
    }
  };

  const validateEmailNotificationInput = (notification) => {
    const isValid = emailValidation(notification);
    if (isValid || notification?.trim() === "") {
      const checkItAlreadyExists = widgetData?.emailNotification?.find(
        (website) => website === notification
      );
      if (checkItAlreadyExists) {
        setFormError({
          ...formError,
          widgetEmailNotificationError: "Email already exists.",
        });
      } else {
        setFormError({ ...formError, widgetEmailNotificationError: "" });
      }
    } else {
      setFormError({
        ...formError,
        widgetEmailNotificationError: "Please enter valid email",
      });
    }
  };

  const setWebsitesData = (data) => {
    handleChange({
      target: {
        name: "websites",
        value: data,
      },
    });
  };

  const setNotificationData = (data) => {
    handleChange({
      target: {
        name: "emailNotification",
        value: data,
      },
    });
  };

  const onClickGetEmbeddedCode = async () => {
    const body = {
      urls: widgetData?.websites,
    };
    const result = await dispatch(
      updateWebsiteWidgetLink({ id: assistantId, body })
    );
    if (
      updateWebsiteWidgetLink.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setShowWidgetEmbeddedCode(true);
    } else {
      setIsLoading(false);
      showErrorMessage(result?.payload?.error?.message);
    }
  };

  return (
    <div
      className={
        isTabSelected
          ? "tabsContent__content tabsContent__content--selected"
          : "tabsContent__content"
      }
    >
      {showWidgetEmbeddedCode ? (
        <WidgetEmbeddedModal
          websites={widgetData?.websites}
          assistantId={assistantId}
          onClose={() => setShowWidgetEmbeddedCode(false)}
        />
      ) : null}
      <div className="assistantWidgetWrap">
        <div className="assistantWidgetWrap__head">
          <div className="formRow">
            <div className="formCol">
              <div className="form__Field">
                <label className="form__label form__label--sm">
                  Website URL
                </label>
                <div className="form__groupField form__groupField--urlPicker">
                  <div className="urlPickerInfo">
                    <span className="urlText">https://</span>
                    <ChipsInput
                      value={widgetData?.websites}
                      onChange={setWebsitesData}
                      isValid={!formError?.widgetWebsiteUrlError}
                      placeholder="URL"
                      validateInput={validateInput}
                    />
                  </div>
                  {Array.isArray(widgetData?.websites) &&
                  widgetData?.websites?.length ? (
                    <Tooltip
                      title={
                        !assistantId ? "Assistant need to be published" : ""
                      }
                      placement="top"
                      arrow
                    >
                      <span
                        className={`backBtn ${
                          !assistantId ? "backBtn--disabled" : ""
                        }`}
                        onClick={assistantId ? onClickGetEmbeddedCode : null}
                      >
                        <CodeTagIcon />
                        Get Embedded Code
                      </span>
                    </Tooltip>
                  ) : null}
                </div>
                {formError?.widgetWebsiteUrlError ? (
                  <div className="form__error">
                    {formError?.widgetWebsiteUrlError}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <div className="formRow formRow__2">
            <div className="formCol">
              <div className="form__Field">
                <label for="widgetColor" className="form__label">
                  Widget Color:
                </label>
                <div className="form__groupField form__groupField--colorPicker">
                  <div className="colorPickerInfo">
                    <input
                      type="color"
                      id="widgetColor"
                      name="widgetColor"
                      value={widgetData.widgetColor}
                      onChange={handleChange}
                      className="form__input form__input--sm"
                      placeholder="#FFFFFF"
                    />
                    <span className="colorPickerInfo__colorName">
                      {widgetData.widgetColor}
                    </span>
                  </div>
                  <span className="text">
                    <input
                      type="text"
                      name="widgetColorOpacity"
                      className="form__input"
                      value={widgetData?.widgetColorOpacity}
                      onChange={handleChange}
                    />
                    %
                  </span>
                </div>
              </div>
            </div>
            <div className="formCol">
              <div className="formRow formRow__2">
                <div className="formCol">
                  <div className="form__Field">
                    <label for="width" className="form__label">
                      Width:
                    </label>
                    <input
                      type="text"
                      id="width"
                      className="form__input form__input--sm"
                      placeholder=""
                      name="widgetWidth"
                      value={widgetData.widgetWidth}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="formCol">
                  <div className="form__Field">
                    <label for="height" className="form__label">
                      Height:
                    </label>
                    <input
                      type="text"
                      id="height"
                      className="form__input form__input--sm"
                      placeholder=""
                      name="widgetHeight"
                      value={widgetData.widgetHeight}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="assistantWidgetWrap__body">
          <div className="formRow formRow__2">
            <div className="formCol">
              <div className="form__group">
                <label className="form__label">Widget:</label>
                <div className="form__radio form__radio--widget">
                  {WidgetIcons?.map((item) => (
                    <div
                      className="form__radio__option"
                      onClick={() =>
                        handleChange({
                          target: {
                            name: "desktopWidgetIcon",
                            value: item.id,
                          },
                        })
                      }
                    >
                      <input
                        type="radio"
                        checked={widgetData.desktopWidgetIcon == item.id}
                        id="desktopWidget"
                        className="form__radio__input"
                      />
                      <label className="form__radio__label" for="desktopWidget">
                        <span className="icon">{item.icon()}</span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="formCol">
              <div className="form__group">
                <label className="form__label">Widget Position:</label>
                <div className="form__radio form__radio--widgetPosition">
                  <div
                    className="form__radio__option"
                    onClick={() =>
                      handleChange({
                        target: {
                          name: "desktopWidgetIconPosition",
                          value: WIDGET_POSITION.TOP_LEFT,
                        },
                      })
                    }
                  >
                    <input
                      type="radio"
                      checked={
                        widgetData.desktopWidgetIconPosition ===
                        WIDGET_POSITION.TOP_LEFT
                      }
                      id="desktopWidgetPosition"
                      className="form__radio__input"
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition"
                    >
                      <span className="icon">
                        <TopLeftIcon />
                      </span>
                    </label>
                  </div>
                  <div
                    className="form__radio__option"
                    onClick={() =>
                      handleChange({
                        target: {
                          name: "desktopWidgetIconPosition",
                          value: WIDGET_POSITION.TOP_MID,
                        },
                      })
                    }
                  >
                    <input
                      type="radio"
                      checked={
                        widgetData.desktopWidgetIconPosition ===
                        WIDGET_POSITION.TOP_MID
                      }
                      id="desktopWidgetPosition"
                      className="form__radio__input"
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition"
                    >
                      <span className="icon">
                        <TopMidIcon />
                      </span>
                    </label>
                  </div>
                  <div
                    className="form__radio__option"
                    onClick={() =>
                      handleChange({
                        target: {
                          name: "desktopWidgetIconPosition",
                          value: WIDGET_POSITION.TOP_RIGHT,
                        },
                      })
                    }
                  >
                    <input
                      type="radio"
                      checked={
                        widgetData.desktopWidgetIconPosition ===
                        WIDGET_POSITION.TOP_RIGHT
                      }
                      id="desktopWidgetPosition"
                      className="form__radio__input"
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition"
                    >
                      <span className="icon">
                        <TopRightIcon />
                      </span>
                    </label>
                  </div>

                  <div
                    className="form__radio__option"
                    onClick={() =>
                      handleChange({
                        target: {
                          name: "desktopWidgetIconPosition",
                          value: WIDGET_POSITION.MID_LEFT,
                        },
                      })
                    }
                  >
                    <input
                      type="radio"
                      checked={
                        widgetData.desktopWidgetIconPosition ===
                        WIDGET_POSITION.MID_LEFT
                      }
                      id="desktopWidgetPosition"
                      className="form__radio__input"
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition"
                    >
                      <span className="icon">
                        <LeftMidIcon />
                      </span>
                    </label>
                  </div>
                  <div
                    className="form__radio__option"
                    onClick={() =>
                      handleChange({
                        target: {
                          name: "desktopWidgetIconPosition",
                          value: WIDGET_POSITION.MID_RIGHT,
                        },
                      })
                    }
                  >
                    <input
                      type="radio"
                      checked={
                        widgetData.desktopWidgetIconPosition ===
                        WIDGET_POSITION.MID_RIGHT
                      }
                      id="desktopWidgetPosition"
                      className="form__radio__input"
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition"
                    >
                      <span className="icon">
                        <MidRightIcon />
                      </span>
                    </label>
                  </div>
                  <div
                    className="form__radio__option"
                    onClick={() =>
                      handleChange({
                        target: {
                          name: "desktopWidgetIconPosition",
                          value: WIDGET_POSITION.BOTTOM_LEFT,
                        },
                      })
                    }
                  >
                    <input
                      type="radio"
                      checked={
                        widgetData.desktopWidgetIconPosition ===
                        WIDGET_POSITION.BOTTOM_LEFT
                      }
                      id="desktopWidgetPosition"
                      className="form__radio__input"
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition"
                    >
                      <span className="icon">
                        <BottomLeftIcon />
                      </span>
                    </label>
                  </div>
                  <div
                    className="form__radio__option"
                    onClick={() =>
                      handleChange({
                        target: {
                          name: "desktopWidgetIconPosition",
                          value: WIDGET_POSITION.BOTTOM_MID,
                        },
                      })
                    }
                  >
                    <input
                      type="radio"
                      checked={
                        widgetData.desktopWidgetIconPosition ===
                        WIDGET_POSITION.BOTTOM_MID
                      }
                      id="desktopWidgetPosition"
                      className="form__radio__input"
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition"
                    >
                      <span className="icon">
                        <MidBottomIcon />
                      </span>
                    </label>
                  </div>
                  <div
                    className="form__radio__option"
                    onClick={() =>
                      handleChange({
                        target: {
                          name: "desktopWidgetIconPosition",
                          value: WIDGET_POSITION.BOTTOM_RIGHT,
                        },
                      })
                    }
                  >
                    <input
                      type="radio"
                      checked={
                        widgetData.desktopWidgetIconPosition ===
                        WIDGET_POSITION.BOTTOM_RIGHT
                      }
                      id="desktopWidgetPosition"
                      className="form__radio__input"
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition"
                    >
                      <span className="icon">
                        <BottomRightIcon />
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="formRow formRow__2">
            <div className="formCol">
              <div className="form__group">
                <label className="form__label">Mobile Widget:</label>
                <div className="form__radio form__radio--widget">
                  {WidgetIcons?.map((item, index) => (
                    <div
                      className="form__radio__option"
                      onClick={() =>
                        handleChange({
                          target: {
                            name: "mobileWidgetIcon",
                            value: item.id,
                          },
                        })
                      }
                    >
                      <input
                        type="radio"
                        checked={widgetData.mobileWidgetIcon == item.id}
                        id={"mobileWidget" + index}
                        className="form__radio__input"
                      />
                      <label
                        className="form__radio__label"
                        for={"mobileWidget" + index}
                      >
                        <span className="icon">{item?.icon()}</span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="formCol">
              <div className="form__group">
                <label className="form__label">Mobile Widget Position:</label>
                <div className="form__radio">
                  <div className="form__radio__option">
                    <input
                      type="radio"
                      checked={
                        widgetData.mobileWidgetIconPosition ===
                        WIDGET_POSITION.BOTTOM_RIGHT
                      }
                      onClick={() =>
                        handleChange({
                          target: {
                            name: "mobileWidgetIconPosition",
                            value: WIDGET_POSITION.BOTTOM_RIGHT,
                          },
                        })
                      }
                      id="desktopWidgetPosition"
                      className="form__radio__input"
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition"
                    >
                      <span className="icon">
                        <MobileBottomRightIcon />
                      </span>
                    </label>
                  </div>
                  <div className="form__radio__option">
                    <input
                      type="radio"
                      id="desktopWidgetPosition2"
                      className="form__radio__input"
                      checked={
                        widgetData.mobileWidgetIconPosition ===
                        WIDGET_POSITION.MID_RIGHT
                      }
                      onClick={() =>
                        handleChange({
                          target: {
                            name: "mobileWidgetIconPosition",
                            value: WIDGET_POSITION.MID_RIGHT,
                          },
                        })
                      }
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition2"
                    >
                      <span className="icon">
                        <MobileMidRightIcon />
                      </span>
                    </label>
                  </div>
                  <div className="form__radio__option">
                    <input
                      type="radio"
                      id="desktopWidgetPosition3"
                      className="form__radio__input"
                      checked={
                        widgetData.mobileWidgetIconPosition ===
                        WIDGET_POSITION.BOTTOM_MID
                      }
                      onClick={() =>
                        handleChange({
                          target: {
                            name: "mobileWidgetIconPosition",
                            value: WIDGET_POSITION.BOTTOM_MID,
                          },
                        })
                      }
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition3"
                    >
                      <span className="icon">
                        <MobileMidBottomIcon />
                      </span>
                    </label>
                  </div>
                  <div className="form__radio__option">
                    <input
                      type="radio"
                      id="desktopWidgetPosition4"
                      className="form__radio__input"
                      checked={
                        widgetData.mobileWidgetIconPosition ===
                        WIDGET_POSITION.MID_MID
                      }
                      onClick={() =>
                        handleChange({
                          target: {
                            name: "mobileWidgetIconPosition",
                            value: WIDGET_POSITION.MID_MID,
                          },
                        })
                      }
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition4"
                    >
                      <span className="icon">
                        <MobileMidMidIcon />
                      </span>
                    </label>
                  </div>
                  <div className="form__radio__option">
                    <input
                      type="radio"
                      id="desktopWidgetPosition5"
                      className="form__radio__input"
                      checked={
                        widgetData.mobileWidgetIconPosition ===
                        WIDGET_POSITION.TOP_RIGHT
                      }
                      onClick={() =>
                        handleChange({
                          target: {
                            name: "mobileWidgetIconPosition",
                            value: WIDGET_POSITION.TOP_RIGHT,
                          },
                        })
                      }
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition5"
                    >
                      <span className="icon">
                        <MobileTopRightIcon />
                      </span>
                    </label>
                  </div>
                  <div className="form__radio__option">
                    <input
                      type="radio"
                      id="desktopWidgetPosition6"
                      className="form__radio__input"
                      checked={
                        widgetData.mobileWidgetIconPosition ===
                        WIDGET_POSITION.MID_LEFT
                      }
                      onClick={() =>
                        handleChange({
                          target: {
                            name: "mobileWidgetIconPosition",
                            value: WIDGET_POSITION.MID_LEFT,
                          },
                        })
                      }
                    />
                    <label
                      className="form__radio__label"
                      for="desktopWidgetPosition6"
                    >
                      <span className="icon">
                        <MobileLeftMidIcon />
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="assistantWidgetWrap__body">
          <div className="formRow formRow__2">
            <div className="formCol">
              <div className="form__Field">
                <label for="headerBackgroundColor" className="form__label">
                  Header Background Color:
                </label>
                <div className="form__groupField form__groupField--colorPicker">
                  <div className="colorPickerInfo">
                    <input
                      type="color"
                      id="headerBackgroundColor"
                      className="form__input form__input--sm"
                      placeholder="#FFFFFF"
                      name="headerBgColor"
                      value={widgetData.headerBgColor}
                      onChange={handleChange}
                    />
                    <span className="colorPickerInfo__colorName">
                      {widgetData.headerBgColor}
                    </span>
                  </div>
                  <span className="text">
                    <input
                      type="text"
                      name="headerBgColorOpacity"
                      className="form__input"
                      value={widgetData?.headerBgColorOpacity}
                      onChange={handleChange}
                    />
                    %
                  </span>
                </div>
              </div>
            </div>
            <div className="formCol">
              <div className="form__Field">
                <label for="headerTextColor" className="form__label">
                  Header Text Color:
                </label>
                <div className="form__groupField form__groupField--colorPicker">
                  <div className="colorPickerInfo">
                    <input
                      type="color"
                      id="headerTextColor"
                      className="form__input form__input--sm"
                      placeholder="#FFFFFF"
                      name="headerTextColor"
                      value={widgetData.headerTextColor}
                      onChange={handleChange}
                    />
                    <span className="colorPickerInfo__colorName">
                      {widgetData.headerTextColor}
                    </span>
                  </div>
                  <span className="text">
                    <input
                      type="text"
                      name="headerTextColorOpacity"
                      className="form__input"
                      value={widgetData?.headerTextColorOpacity}
                      onChange={handleChange}
                    />
                    %
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="formRow formRow__2">
            <div className="formCol">
              <div className="form__Field">
                <label
                  for="headingText"
                  className="form__label form__label--sm"
                >
                  Heading Text
                </label>
                <input
                  type="text"
                  id="headingText"
                  className="form__input form__input--sm"
                  placeholder="Heading Text"
                  name="headerText"
                  value={widgetData.headerText}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="formCol">
              <div className="form__Field">
                <label
                  for="contentText"
                  className="form__label form__label--sm"
                >
                  Content Text
                </label>
                <input
                  type="text"
                  id="contentText"
                  className="form__input form__input--sm"
                  placeholder="Content Text"
                  name="contentText"
                  value={widgetData.contentText}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="formRow formRow__2">
            <div className="formCol">
              <div className="form__Field">
                <label
                  for="firstMessage"
                  className="form__label form__label--sm"
                >
                  First Message (Override)
                </label>
                <input
                  type="text"
                  id="firstMessage"
                  className="form__input form__input--sm"
                  placeholder="First Message"
                  name="firstWidgetMessage"
                  value={widgetData.firstWidgetMessage}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="formCol">
              <div className="form__Field">
                <label
                  for="emailNotification"
                  className="form__label form__label--sm"
                >
                  Email Notification
                </label>
                <div className="form__groupField form__groupField--urlPicker">
                  <div className="urlPickerInfo">
                    <ChipsInput
                      value={widgetData?.emailNotification}
                      onChange={setNotificationData}
                      style={{ width: "100%", borderRadius: "0.375rem" }}
                      isValid={!formError?.widgetEmailNotificationError}
                      placeholder="Enter email address"
                      validateInput={validateEmailNotificationInput}
                    />
                  </div>
                </div>
                {formError?.widgetEmailNotificationError ? (
                  <div className="form__error">
                    {formError?.widgetEmailNotificationError}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="formCol">
              <div className="form__Field">
                <label
                  for="callForward"
                  className="form__label form__label--sm"
                >
                  Call Forward # (Override)
                </label>
                <CountryPhoneInput
                  countryCodeFieldName="forwardingCountryCallingCode"
                  phoneFieldName="forwardingPhoneNumber"
                  countryCode={widgetData.forwardingCountryCallingCode}
                  phoneNumber={widgetData.forwardingPhoneNumber}
                  onCountryChange={handleChange}
                  onPhoneChange={handleChange}
                />
                {formError?.widgetForwardingPhoneError ? (
                  <div className="form__error">
                    {formError?.widgetForwardingPhoneError}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/* <div className="formRow formRow__2"></div> */}
        </div>
      </div>
    </div>
  );
};

export default WebsiteWidgetTab;
